module.exports = __webpack_public_path__ + "images/wheel-icon-valentines-19b8b8dcdef9bd59de7f2811a17005fb.png";